import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Add class to body to remove global styles
    document.body.style.padding = '0';
    document.body.style.margin = '0';

    return () => {
      // Cleanup
      document.body.style.padding = '';
      document.body.style.margin = '';
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(email, password);
      navigate('/admin');
    } catch (error) {
      console.error('Login error:', error);
      setError('Failed to sign in. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  const containerStyle = {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f8f8f8',
    padding: '20px',
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
  };

  const loginCardStyle = {
    backgroundColor: '#fff',
    borderRadius: '0',
    border: '1px solid #ececec',
    padding: '60px 40px',
    width: '100%',
    maxWidth: '400px',
    boxShadow: 'none'
  };

  const headerStyle = {
    textAlign: 'center',
    marginBottom: '40px'
  };

  const logoStyle = {
    width: '80px',
    height: 'auto',
    marginBottom: '20px'
  };

  const titleStyle = {
    fontSize: '28px',
    fontWeight: '600',
    color: '#222',
    margin: '0 0 8px 0',
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
  };

  const subtitleStyle = {
    fontSize: '14px',
    color: '#666',
    margin: '0',
    fontFamily: 'Georgia, serif'
  };

  const errorMessageStyle = {
    backgroundColor: '#fef2f2',
    color: '#dc2626',
    padding: '12px 16px',
    borderRadius: '0',
    border: '1px solid #fecaca',
    fontSize: '14px',
    marginBottom: '20px',
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
  };

  const formStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px'
  };

  const formGroupStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  };

  const labelStyle = {
    fontSize: '14px',
    fontWeight: '500',
    color: '#222',
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
  };

  const inputStyle = {
    padding: '12px 16px',
    fontSize: '14px',
    border: '1px solid #ececec',
    borderRadius: '0',
    backgroundColor: '#fff',
    color: '#222',
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    outline: 'none',
    transition: 'border-color 0.2s ease'
  };

  const inputFocusStyle = {
    borderColor: '#222'
  };

  const submitButtonStyle = {
    backgroundColor: '#222',
    color: '#fff',
    border: 'none',
    padding: '14px 24px',
    fontSize: '14px',
    fontWeight: '500',
    cursor: loading ? 'not-allowed' : 'pointer',
    marginTop: '10px',
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    opacity: loading ? 0.7 : 1,
    transition: 'opacity 0.2s ease'
  };

  return (
    <div style={containerStyle}>
      <div style={loginCardStyle}>
        <div style={headerStyle}>
          <img src="/images/logo.png" alt="Grey Official Logo" style={logoStyle} />
          <h1 style={titleStyle}>Admin Portal</h1>
          <p style={subtitleStyle}>Sign in to your account</p>
        </div>

        {error && (
          <div style={errorMessageStyle}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} style={formStyle}>
          <div style={formGroupStyle}>
            <label htmlFor="email" style={labelStyle}>
              Email Address
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={inputStyle}
              onFocus={(e) => Object.assign(e.target.style, inputFocusStyle)}
              onBlur={(e) => Object.assign(e.target.style, inputStyle)}
              placeholder="Enter your email address"
              required
              disabled={loading}
            />
          </div>

          <div style={formGroupStyle}>
            <label htmlFor="password" style={labelStyle}>
              Password
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={inputStyle}
              onFocus={(e) => Object.assign(e.target.style, inputFocusStyle)}
              onBlur={(e) => Object.assign(e.target.style, inputStyle)}
              placeholder="Enter your password"
              required
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            style={submitButtonStyle}
            disabled={loading}
          >
            {loading ? 'Signing In...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
